module.exports = __webpack_public_path__ + "img/tl4a.7cd9c7e2.jpg";